import { useReducer, useState } from 'react';
import { AppBar, Dialog, IconButton, Toolbar, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { quickMatchReducer, createInitialState } from './quickMatchReducer.ts';
import type { TeamSide } from './quickMatchTypes.ts';
import QuickMatchSetup from './QuickMatchSetup.tsx';
import QuickMatchBoard from './QuickMatchBoard.tsx';

interface QuickMatchDialogProps {
  open: boolean;
  onClose: () => void;
}

const PLACEHOLDER = createInitialState({ homeTeamName: 'Noi', awayTeamName: 'Loro', servingTeam: 'HOME', pointsToWin: 25 });

export default function QuickMatchDialog({ open, onClose }: QuickMatchDialogProps) {
  const [started, setStarted] = useState(false);
  const [state, dispatch] = useReducer(quickMatchReducer, PLACEHOLDER);

  const handleStart = (params: { homeTeamName: string; awayTeamName: string; servingTeam: TeamSide; pointsToWin: number }) => {
    dispatch({ type: 'INIT', ...params });
    setStarted(true);
  };

  const handleClose = () => {
    setStarted(false);
    dispatch({ type: 'INIT', homeTeamName: 'Noi', awayTeamName: 'Loro', servingTeam: 'HOME', pointsToWin: 25 });
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullScreen>
      <AppBar position="static" color="primary">
        <Toolbar>
          <Typography variant="h6" sx={{ flex: 1, fontWeight: 700 }}>
            Partita Veloce
          </Typography>
          <IconButton color="inherit" onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      {!started ? (
        <QuickMatchSetup onStart={handleStart} />
      ) : (
        <QuickMatchBoard state={state} dispatch={dispatch} onClose={handleClose} />
      )}
    </Dialog>
  );
}
